import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function AdjustLimit({ fetchUser, setShowDeduct }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [amount, setAmount] = useState(0)

  async function updateDebt() {
    const data = {
      creditLimit: amount,
    }
    if (amount < 1) {
      notify('warn', 'Input Amount')
      return
    }
    setCancelLoading(true)
    put(`admin/business/change-limit/${id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Debt Updated')
          setShowDeduct(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Adjust Business's limit</h1>
        <p>Note: will change the limit of the business</p>
        <input
          type='number'
          min={1}
          placeholder='Enter Amount'
          onChange={(e) => setAmount(parseFloat(e.target.value))}
        />
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowDeduct(false)}>Cancel</button>
            <button className='proceed' onClick={updateDebt}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default AdjustLimit
